import { useAtomValue } from "../app-jotai";

import { saveStateAtom } from "../app-jotai";

import "./SavingIndicator.scss";

export const SavingIndicator = () => {
  const saveState = useAtomValue(saveStateAtom);

  return (
    <div
      className={`saving-indicator saving-indicator--${saveState}`}
      aria-live="polite"
    >
      {saveState === "saving" ? (
        <>
          <span className="saving-indicator__spinner" />
          <span>Saving...</span>
        </>
      ) : saveState === "saved" ? (
        <span className="saving-indicator__saved">✓ Saved</span>
      ) : (
        <span className="saving-indicator__unsaved">● Unsaved changes</span>
      )}
    </div>
  );
};
